// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-70026cc7] .leader-data .el-form .is-disabled * {\r\n  color: blue !important;\n}\n[data-v-70026cc7] .el-upload .el-button {\r\n  display: none !important;\n}\n[data-v-70026cc7] .el-upload-list__item-status-label {\r\n  display: none !important;\n}\n[data-v-70026cc7] .el-icon-close {\r\n  display: none !important;\n}\n.full-height[data-v-70026cc7] {\r\n  position: relative;\r\n  height: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
